import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const videoRecordersRoutes = {
  [ERouteMappingKeys.VIDEO_RECORDERS]: {
    id: "video-recorders",
    path: "/camera-security/video-recorders",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/CameraSecurity/VideoRecorders").then((p) => ({
          default: p.VideoRecorders,
        })),
      ),
    },
  },
};
